export const showAddBlogModal = () => {
    return {
      type: "SHOW_ADD_BLOG_MODAL",
    };
  };
  
  export const hideAddBlogModal = () => {
    return {
      type: "HIDE_ADD_BLOG_MODAL",
    };
  };
  